var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "typebox"
  }, [_vm.showSticker ? _c('div', {
    staticClass: "sticker d-flex flex-column"
  }, [_c('div', {
    staticClass: "sticker-header d-flex align-items-start"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap"
  }, [_c('b-button', {
    staticClass: "p-0 rounded-0 px-2",
    on: {
      "click": _vm.switchStickerSet
    }
  }, [_vm.isSticker ? _c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,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"
    }
  }) : _c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,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"
    }
  })]), _vm._l(_vm.itemSets, function (i, idx) {
    return [_c('b-button', {
      key: i,
      class: ['p-0', 'rounded-0', _vm.setIndex == idx && 'active'],
      attrs: {
        "variant": "link"
      },
      on: {
        "click": function click($event) {
          _vm.setIndex = idx;
        }
      }
    }, [_vm.isSticker ? _c('img', {
      attrs: {
        "src": _vm.getImage("sticker/tab/".concat(i, "_tab.png"))
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.getImage("sticon/tab/".concat(i, "_tab.png"))
      }
    })])];
  })], 2), _c('button', {
    staticClass: "btn btn-link p-2 text-dark ml-auto",
    on: {
      "click": function click($event) {
        _vm.showSticker = !_vm.showSticker;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('div', {
    staticClass: "sticker-body"
  }, [_vm._l(_vm.items.filter(function (x) {
    return x.set == _vm.itemSets[_vm.setIndex];
  }), function (j, jdx) {
    return [_c('b-button', {
      key: jdx,
      class: ['p-1', 'rounded-0', _vm.isSticker ? 'stk' : 'emoji'],
      attrs: {
        "variant": "link"
      },
      on: {
        "click": function click($event) {
          _vm.isSticker ? _vm.insertSticker(j.set, j.id) : _vm.insertEmoji(j.set, j.id);
        }
      }
    }, [_vm.isSticker ? _c('img', {
      attrs: {
        "src": _vm.getImage("sticker/".concat(j.id, "_S.png"))
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.getImage("sticon/".concat(j.set, "/").concat(j.id, "_S.png"))
      }
    })])];
  })], 2)]) : _vm._e(), _c('div', {
    staticClass: "d-flex p-2 position-relative"
  }, [_vm.canSticker ? _c('button', {
    staticClass: "btn btn-link px-2 text-dark align-self-start",
    on: {
      "click": _vm.toggleSticker
    }
  }, [_c('i', {
    staticClass: "fa fa-smile-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm.canImage ? _c('button', {
    staticClass: "btn btn-link px-2 text-dark align-self-start upload-button"
  }, [_c('i', {
    staticClass: "fa fa-picture-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('b-form-file', {
    attrs: {
      "accept": "image/jpeg, image/png, image/gif",
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": _vm.uploadImage
    }
  })], 1) : _vm._e(), _vm.canAttach ? _c('button', {
    staticClass: "btn btn-link px-2 text-dark align-self-start upload-button"
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('b-form-file', {
    attrs: {
      "accept": "image/jpeg, image/png, image/gif",
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": _vm.uploadFile
    }
  })], 1) : _vm._e(), _c('b-dropdown', {
    staticClass: "p-0 btn btn-link align-self-start",
    attrs: {
      "dropup": "",
      "variant": " p-2",
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fa fa-paperclip",
          attrs: {
            "aria-hidden": "true"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    attrs: {
      "href": "#",
      "link-class": "d-flex justify-content-between align-items-center"
    }
  }, [_c('span', [_vm._v("單檔")]), _c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('b-dropdown-item', {
    attrs: {
      "href": "#",
      "link-class": "d-flex justify-content-between align-items-center"
    }
  }, [_c('span', [_vm._v("多檔")]), _c('img', {
    attrs: {
      "src": require("@/assets/images/liff/chatbox/paperclip-2.png"),
      "width": "18",
      "height": "18"
    }
  })])], 1), _c('div', {
    staticClass: "flex-fill align-self-stretch position-relative message-wrapper"
  }, [_c('textarea', {
    ref: "message",
    staticClass: "p-2 pr-5 message",
    attrs: {
      "placeholder": "輸入留言",
      "rows": "1"
    },
    on: {
      "input": _vm.inputMessage,
      "click": _vm.changeCaret,
      "keyup": _vm.changeCaret
    }
  }), _c('div', {
    staticClass: "message-overlay p-2 pr-5",
    domProps: {
      "innerHTML": _vm._s(_vm.parseMessage)
    }
  }), _c('button', {
    staticClass: "btn send px-2",
    attrs: {
      "type": "submit"
    }
  }, [_c('svg', {
    attrs: {
      "width": "21",
      "height": "18",
      "viewBox": "0 0 21 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.17 6.22991L5.17001 0.449907C4.64029 0.230693 4.05884 0.167851 3.49451 0.26882C2.93018 0.369788 2.4066 0.630339 1.98575 1.01963C1.5649 1.40891 1.2644 1.91064 1.11983 2.4654C0.975262 3.02016 0.992675 3.60473 1.17001 4.14991L2.71001 8.99991L1.13001 13.8499C0.947881 14.3973 0.927422 14.9855 1.07108 15.5442C1.21475 16.1029 1.51644 16.6083 1.94001 16.9999C2.48465 17.505 3.19729 17.79 3.94001 17.7999C4.33474 17.7996 4.72554 17.7215 5.09001 17.5699L19.14 11.7899C19.6872 11.5623 20.1547 11.1778 20.4836 10.6848C20.8125 10.1919 20.988 9.61252 20.988 9.01991C20.988 8.42729 20.8125 7.84795 20.4836 7.35497C20.1547 6.862 19.6872 6.47747 19.14 6.24991L19.17 6.22991ZM4.36001 15.6999C4.18361 15.7727 3.99007 15.7934 3.80225 15.7598C3.61442 15.7261 3.44015 15.6394 3.30001 15.5099C3.168 15.3838 3.07304 15.2239 3.02545 15.0476C2.97785 14.8713 2.97943 14.6854 3.03001 14.5099L4.49001 9.99991H18.22L4.36001 15.6999ZM4.49001 7.99991L3.00001 3.52991C2.94943 3.35446 2.94785 3.16851 2.99545 2.99222C3.04304 2.81594 3.138 2.65606 3.27001 2.52991C3.36412 2.43118 3.47742 2.35275 3.60296 2.29944C3.7285 2.24613 3.86362 2.21906 4.00001 2.21991C4.13406 2.22016 4.26669 2.24737 4.39001 2.29991L18.22 7.99991H4.49001Z",
      "fill": "#09101D"
    }
  })])])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }